// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ace0f36","732":"1bbdf41d","977":"22739741"}[chunkId] + ".chunk.js";
};